import * as Sentry from '@sentry/browser';
import { getSentryConfig } from 'shared/logger/config/getSentryConfig';
import { LogData } from 'shared/types/logger';
import { version } from '../../../package.json';
import { isSentryEnabled } from 'shared/utils/environment/variables';
import { sentryLog } from 'shared/logger/sentryLog';

export async function initSentryInSW(): Promise<void> {
  if (isSentryEnabled()) {
    Sentry.init({
      ...getSentryConfig('ServiceWorker', version),
      integrations: [
        Sentry.extraErrorDataIntegration(),
        Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
      ],
    });
  }
}

export function swSentryLog(data: LogData): void {
  sentryLog(Sentry, data);
}
